import React, {Component} from 'react';
import {FILE_NAME} from '../../resources/constant';
import {Table} from 'react-bootstrap';
//import {ViewPre} from '../../theme/MorsTheme';
export default class ViewReportFile extends Component{      

    constructor(props){
        super(props);
      
        this.state = {
            //rsp:JSON.parse(localStorage.getItem(FILE_NAME)), 
            rsp:JSON.parse(localStorage.getItem(localStorage.getItem(FILE_NAME))),
                       
        }
    }

    componentDidMount(){        

    }

    componentWillUnmount(){
        alert("willunmount");              
        localStorage.removeItem(FILE_NAME);
        localStorage.removeItem(localStorage.removeItem(FILE_NAME));    
        this.setState({
            rsp:''
        })         
    }

    render(){                  
        return(                   
            <div>
            <div style={{background:'#0B2972', height:"30px"}}>
            <div align="center">
            <span style={{color:'#FFFFFF', textAlign:'center'}} >
                <font style={{color:'#FFFFFF', size:'2'}}>
                    {this.state.rsp.map(x => x.fileName)}
                </font>
            </span>
            </div>
                
            </div>
            <div>
            
          <Table>
              <tr>
                  <td>                     
                    <pre>{this.state.rsp.map(x => x.response)}</pre>                  
                  </td>
              </tr>
          </Table>
          </div>
    </div>
        )
    }
}

